import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";
import emptyDocument from "../../assets/images/fallback.svg";
import { ClinicCard, DocumentCard } from "../../components/Cards/Cards";
import ProcessSuccess from "../../components/ProcessSuccess/ProcessSuccess";
import TermsAndConditionModal from "../../components/TermsAndConditionModal/TermsAndConditionModal";
import {
  ArrowIcon,
  CrashIcon
} from "../../front-end-global-components/assets/assets";
import Button from "../../front-end-global-components/components/Button/Button";
import CheckBox from "../../front-end-global-components/components/CheckBox/CheckBox";
import Header from "../../front-end-global-components/components/Header/Header";
import InputBox from "../../front-end-global-components/components/InputBox/InputBox";
import Modal from "../../front-end-global-components/components/Modal/Modal";
import OTPInputBox from "../../front-end-global-components/components/OTPInputBox/OTPInputBox";
import {
  clearAbdmAuthCredentials,
  clearLinkRefNumber,
  confirmOtpToLinkAbdmCareContext,
  discoverCareContextWithClinicId,
  getScannedClinicDetails,
  sendOtpToLinkAbdmCareContext,
  setSearchHistory,
  shareProfile
} from "../../redux/abdm/actions";
import { getPatientsCareContexts } from "../../redux/patients/actions";
import { setErrorStatus } from "../../redux/status/actions";
import { deFormatABHANumber, getValidGender } from "../../utils/constants";
import { isValidArray, isValidObject } from "../../utils/validators";
import "./Abdm.css";

export const ViewSearchedClinicCareContext = (props) => {
  const { clinicId } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  const [OTPValue, setOTPValue] = useState(null);
  const [careContext, setCareContext] = useState({});
  const [clinicDetails, setClinicDetails] = useState({});
  const [selectedCareContexts, setSelectedCareContexts] = useState({});
  const [isAgreed, setIsAgreed] = useState(false);
  const [healthData, setHealthData] = useState(null);
  const [patientId, setPatientId] = useState(null);
  //for now hard coded
  const [locationAccess, setLocationAccess] = useState("granted");
  const [currentLocation, setCurrentLocation] = useState({
    latitude: "13.130928565366448",
    longitude: "79.9643925221393"
  });

  const [options, setOptions] = useState([
    {
      name: "Fetch Record",
      description:
        "You can fetch records which has been uploaded by your clinic",
      "data-cy": "FETCH-RECORDS-MENU",
      onClick: () => navigate(`/clinicSearch/${clinicId}/patientDetails`)
    }
    // {
    //   name: "Book Appointment",
    //   description: "You can able to book appointment with your clinic",
    //   "data-cy": "bookAppointment-menu",
    // onClick: () => navigate(`/clinicSearch/${clinicId}/bookAppointment`)
    // },
    // {
    //   name: "Blood Request",
    //   description:
    //     "You can able to donate your blood in your nearest or requested clinic",
    //   "data-cy": "bloodRequest-menu",
    // onClick: () => navigate(`/clinicSearch/${clinicId}/bloodRequest`)
    // }
  ]);

  const currentMenu = location.pathname.split("/").pop();

  useEffect(() => {
    if (props.abdm.clinics?.search?.linkRefNumber) {
      navigate(`/clinicSearch/${clinicId}/OTPModal`);
    }
    // eslint-disable-next-line
  }, [props.abdm.clinics?.search?.linkRefNumber]);

  useEffect(() => {
    clearLinkRefNumber();
    navigate(`/clinicSearch/${clinicId}/menu`);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      clinicDetails.hipCode &&
      !isValidObject(options.find((ele) => ele.name === "Share Profile"))
    ) {
      setOptions((prev) => [
        ...prev,
        {
          name: "Share Profile",
          description: "You can share your profile information with the clinic",
          "data-cy": "SHARE-PROFILE-MENU",
          onClick: () => navigate(`/clinicSearch/${clinicId}/share`)
        }
      ]);
    }

    if (
      clinicDetails.hipCode &&
      clinicDetails.token &&
      currentMenu === "share"
    ) {
      navigate(`/clinicSearch/${clinicId}/shareSuccess`);
    }
    // eslint-disable-next-line
  }, [clinicDetails, currentMenu]);

  const fetchCareContextDetails = () => {
    const careContextData =
      props.abdm?.clinics?.search?.careContexts?.[clinicId];
    if (isValidObject(careContextData)) {
      setCareContext(careContextData);
    }
  };

  useEffect(() => {
    const { results, searchHistory } = props.abdm?.clinics?.search;

    if (
      (isValidObject(results) && isValidObject(results?.[clinicId])) ||
      (isValidObject(searchHistory) && isValidObject(searchHistory?.[clinicId]))
    ) {
      return;
    }

    getScannedClinicDetails(clinicId, "search");
  }, [clinicId, props.abdm?.clinics?.search]);

  useEffect(() => {
    if (!clinicId) {
      navigate(-1);
      return;
    }

    const { results, searchHistory, publicHealthPrograms } =
      props.abdm?.clinics?.search || {};

    if (isValidObject(results?.[clinicId])) {
      setClinicDetails(results[clinicId]);
      if (
        searchHistory?.[clinicId] &&
        !isValidObject(searchHistory[clinicId])
      ) {
        setSearchHistory({
          [clinicId]: {
            ...results[clinicId],
            timestamp: Date.now()
          }
        });
      }
    } else if (isValidObject(searchHistory?.[clinicId])) {
      setClinicDetails(searchHistory[clinicId]);
    } else if (isValidObject(publicHealthPrograms?.[clinicId])) {
      setClinicDetails(publicHealthPrograms[clinicId]);
    }
    // eslint-disable-next-line
  }, [clinicId, props.abdm?.clinics?.search]);

  useEffect(() => {
    fetchCareContextDetails();
    // eslint-disable-next-line
  }, [clinicId, props.abdm.clinics.search.careContexts]);

  useEffect(() => {
    const program =
      props.abdm?.clinics?.search?.publicHealthPrograms?.[clinicId];
    if (isValidObject(program)) {
      navigate(`/clinicSearch/${clinicId}/patientDetails`);
    }
    // eslint-disable-next-line
  }, [clinicId, props.abdm?.clinics?.search]);

  useEffect(() => {
    const { healthIdData, currentProfile } = props.patients || {};
    if (healthIdData && currentProfile) {
      setHealthData(healthIdData[currentProfile]);
    }
  }, [props.patients]);

  const patientData = [
    { name: "ABHA ADDRESS", value: healthData?.abhaAddress || "Nill" },
    {
      name: "ABHA NUMBER",
      value: deFormatABHANumber(healthData?.abhaNumber) || "Nill"
    },
    { name: "NAME", value: healthData?.fullName || "Nill" },
    {
      name: "MOBILE NUMBER",
      value: healthData?.mobile ? `+91${healthData.mobile}` : "Nill"
    },
    {
      name: "ADDRESS",
      value: healthData?.address || "Nill"
    },
    { name: "GENDER", value: getValidGender(healthData?.gender) || "Nill" },
    {
      name: "DATE OF BIRTH",
      value: healthData?.dateOfBirth || "Nill"
    }
  ];

  const requestLocationPermission = () => {
    // hardcoded
    setLocationAccess("granted");
    setCurrentLocation({
      latitude: "13.130928565366448",
      longitude: "79.9643925221393"
    });

    // if (!navigator.geolocation) {
    //   setLocationAccess("denied");
    //   return;
    // }
    // navigator.geolocation.getCurrentPosition(
    //   (position) => {
    //     setLocationAccess("granted");
    //     setCurrentLocation({
    //       latitude: position.coords.latitude.toString(),
    //       longitude: position.coords.longitude.toString()
    //     });
    //   },
    //   (error) => {
    //     console.error("Location permission denied or failed", error);
    //     setLocationAccess("denied");
    //   },
    //   { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
    // );
  };

  // useEffect(() => {
  // if (navigator.permissions?.query) {
  //   navigator.permissions.query({ name: "geolocation" }).then((result) => {
  //     setLocationAccess(result.state);
  //     if (result.state === "granted") {
  //       requestLocationPermission();
  //     }
  //     result.addEventListener("change", () => {
  //       setLocationAccess(result.state);
  //       if (result.state === "denied") {
  //         setCurrentLocation(null);
  //       } else if (result.state === "granted") {
  //         requestLocationPermission();
  //       }
  //     });
  //   });
  // } else {
  //   requestLocationPermission();
  // }
  // }, []);

  return (
    <React.Fragment>
      <Header
        title={
          currentMenu === "menu"
            ? "Hospital / lab"
            : currentMenu === "share"
            ? "Share your details"
            : currentMenu === "fetchRecords" || currentMenu === "patientDetails"
            ? "Fetch Records"
            : currentMenu === "bloodRequest"
            ? "Blood Request"
            : currentMenu === "bookAppointment"
            ? "Book Appointment"
            : ""
        }
        backButtonOnClick={() => {
          if (
            isValidObject(
              props.abdm.clinics.search.publicHealthPrograms?.[clinicId]
            )
          ) {
            return navigate("/clinicSearch");
          }
          if (currentMenu === "menu") {
            return navigate("/clinicSearch");
          }
          if (currentMenu === "fetchRecords") {
            return navigate(`/clinicSearch/${clinicId}/patientDetails`);
          }
          return navigate(`/clinicSearch/${clinicId}/menu`);
        }}
        supportIconOnClick={() => {
          navigate("/query");
        }}
        incident={props.app.featureFlags?.incident?.patients}
        incidentOnClick={() => {
          navigate("/incidents");
        }}
      />

      <section className="remaining-body-height max-width-588px margin-horizontal-auto ">
        <ClinicCard
          loading={props.abdm.loading}
          clinicDetails={clinicDetails}
          logoURL={null}
          boldName
        />

        <Routes>
          <Route
            path="/*"
            element={props.abdm.loading ? <DocumentCardLoading /> : <Outlet />}
          >
            <Route
              index
              element={
                <MenuView options={options} loading={props.abdm.loading} />
              }
            />
            <Route
              path="menu"
              element={
                <MenuView options={options} loading={props.abdm.loading} />
              }
            />
            <Route
              path="patientDetails"
              element={
                <PatientDetailsView
                  label={
                    props.clinicDetailsProp?.attributes?.hipAttributes
                      ?.discoveryAdditionalFieldLabel || "PATIENT ID (OPTIONAL)"
                  }
                  patientData={patientData}
                  setPatientId={setPatientId}
                  discoverCareContextWithClinicId={
                    discoverCareContextWithClinicId
                  }
                  loading={props.abdm.loading}
                  onContinueClick={() => {
                    getPatientsCareContexts();
                    discoverCareContextWithClinicId(clinicId, patientId);
                    navigate(`/clinicSearch/${clinicId}/fetchRecords`);
                  }}
                />
              }
            />

            <Route
              path="share"
              element={
                locationAccess !== "granted" && !window.Cypress ? (
                  <PermissionDeniedFallback
                    title={
                      locationAccess === "prompt"
                        ? "Allow Location Permission"
                        : "Location Permission Denied"
                    }
                    description={
                      locationAccess === "prompt"
                        ? "Enables us to monitor your real-time location"
                        : "You have blocked from tracking your location. To use this, change your location settings in browser."
                    }
                    showButton={locationAccess === "prompt"}
                    onEnableClick={() => {
                      requestLocationPermission();
                    }}
                  />
                ) : (
                  <ShareView
                    patientData={patientData}
                    clinicId={clinicId}
                    isAgreed={isAgreed}
                    setIsAgreed={setIsAgreed}
                    loading={props.abdm.loading}
                    shareProfile={shareProfile}
                    searchHistory={props.abdm.clinics.search.searchHistory}
                    currentLocation={currentLocation}
                  />
                )
              }
            />
            <Route
              path="fetchRecords"
              element={
                <section className="remaining-height-of-abdm-clinic-care-context-section ">
                  <FetchPatientRecords
                    location={careContext?.location}
                    otpLoading={props.abdm.OTPLoading}
                    loading={props.abdm.loading}
                    records={careContext}
                    linkedCareContexts={
                      props.patients.careContexts?.[
                        props.patients.currentProfile
                      ]?.[clinicId]
                    }
                    selectedCareContexts={selectedCareContexts}
                    setSelectedCareContexts={setSelectedCareContexts}
                    fetchOnClick={(data) =>
                      sendOtpToLinkAbdmCareContext(data, clinicId)
                    }
                    retryOnClick={() => {
                      getPatientsCareContexts();
                      discoverCareContextWithClinicId(clinicId, patientId);
                    }}
                  />
                </section>
              }
            />
            <Route
              path="shareSuccess"
              element={
                <div className="padding-larger remaining-height-of-abdm-clinic-care-context-section">
                  <ProcessSuccess
                    title={
                      <>
                        Successfully shared your details with{" "}
                        <span className="font-family-gilroy-bold">
                          {clinicDetails?.identifier?.name}
                        </span>
                      </>
                    }
                    description={
                      clinicDetails.token ? (
                        <div>
                          Your{" "}
                          <span className=" font-family-gilroy-bold">
                            token number is {clinicDetails.token}
                          </span>
                          <span>
                            {" "}
                            , please share your token with clinic to proceed
                            further
                          </span>
                          <br />
                          <br />
                          <span>
                            Token Expires in{" "}
                            <span className="font-family-gilroy-bold">
                              60 mins
                            </span>{" "}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )
                    }
                    confirmClick={() => navigate("/")}
                  />
                </div>
              }
            />
            <Route
              path="fetchSuccess"
              element={
                <div
                  style={{
                    height: "calc(100% - 138px)"
                  }}
                  className="padding-larger inherit-parent-width"
                >
                  <ProcessSuccess
                    title="Records Are Successfully Linked"
                    description="PLEASE WAIT A FEW MINUTES FOR YOUR RECORDS TO SHOW UP IN NINTO"
                    confirmClick={() => {
                      // navigate(`/clinicSearch/${clinicId}/menu`);
                      navigate("/");
                    }}
                  />
                </div>
              }
            />
            <Route
              path="terms"
              element={
                <TermsAndConditionModal
                  onClose={() => navigate(`/clinicSearch/${clinicId}`)}
                />
              }
            />
            <Route
              path="OTPModal"
              element={
                <OTPModal
                  disableButton={OTPValue?.length !== 6}
                  loading={props.abdm.OTPLoading}
                  setOTPValue={setOTPValue}
                  fetchRecordsClick={() =>
                    confirmOtpToLinkAbdmCareContext(
                      clinicId,
                      OTPValue,
                      navigate
                    )
                  }
                  resendOTPOnClick={() => {
                    clearLinkRefNumber();
                    sendOtpToLinkAbdmCareContext(
                      selectedCareContexts,
                      clinicId
                    );
                  }}
                />
              }
            />
          </Route>
        </Routes>
      </section>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  abdm: state.abdm,
  patients: state.patients,
  app: state.app
});

const mapDispatchToProps = () => ({
  shareProfile: (clinicId, currentLocation) =>
    shareProfile(clinicId, currentLocation),
  setSearchHistory: (data) => setSearchHistory(data),
  clearAbdmAuthCredentials: () => clearAbdmAuthCredentials()
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewSearchedClinicCareContext);

const MenuView = (props) => {
  return (
    <>
      {props.options.map((data, index) => (
        <div key={index} className="padding-larger">
          <div
            className="display-flex flex-align-items-center flex-justify-content-space-between "
            data-cy={data["data-cy"]}
            onClick={data.onClick}
          >
            <div>
              <div>{data.name}</div>
              <div className="font-size-small padding-top-default padding-right-large">
                {data.description}
              </div>
            </div>
            <ArrowIcon />
          </div>
        </div>
      ))}
    </>
  );
};

const PatientDetailsView = (props) => {
  return (
    <section className="remaining-height-of-abdm-clinic-care-context-section flex-justify-content-space-between display-flex flex-direction-column padding-larger">
      <div>
        <div className="">
          {props.patientData.map((data, index) => (
            <div key={index} className=" padding-bottom-large font-size-medium">
              <div className="padding-bottom-small">{data.name}</div>
              <div
                className={`${
                  data.name === "ABHA ADDRESS" ? "" : "text-capitalize"
                } font-size-small`}
              >
                {data.value}
              </div>
            </div>
          ))}
        </div>
        <div className="flex-justify-content-space-between flex-direction-column">
          <InputBox
            labelClassName="letter-spacing-4-percentage"
            className="inherit-parent-width border-radius-default"
            name="patientId"
            label={props.label}
            onChange={(event) => {
              props.setPatientId(event.target.value);
            }}
            type="text"
            required
          />
        </div>
      </div>
      <div className="inherit-parent-width">
        <Button
          text="Continue"
          boxShadow={false}
          onClick={props.onContinueClick}
          data-cy={"CONTINUE-TO-FETCH-RECORDS"}
        />
      </div>
    </section>
  );
};

const ShareView = (props) => {
  const navigate = useNavigate();
  return (
    <section className="remaining-height-of-abdm-clinic-care-context-section display-flex flex-justify-content-space-between flex-direction-column">
      <div>
        <div className="padding-top-default">
          {props.patientData.map((data, index) => (
            <div
              key={index}
              className="padding-left-large padding-right-large padding-bottom-default padding-top-default font-size-medium"
            >
              <div className="padding-bottom-small">{data.name}</div>
              <div
                className={`${
                  data.name === "ABHA ADDRESS" ? "" : "text-capitalize"
                }  font-size-small`}
              >
                {data.value}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <div className="inherit-parent-width display-flex text-align-left padding-left-large font-size-small font-family-gilroy-medium flex-align-items-center white-space-no-wrap">
          <CheckBox
            name="agreeTo"
            onChange={(event) => {
              props.setIsAgreed(event.target.checked);
            }}
            checked={props.isAgreed}
            label="I agree with"
            required={true}
          />
          <div
            onClick={() => {
              navigate(`/clinicSearch/${props.clinicId}/terms`);
            }}
            className="text-underline-hover font-color-primary padding-left-small cursor-pointer"
          >
            ABDM's terms and conditions
          </div>
        </div>
        <div className="inherit-parent-width padding-left-large padding-right-large padding-left-large padding-top-larger padding-bottom-larger display-flex">
          <Button
            text="Share"
            data-cy="SHARE-PROFILE-BUTTON"
            boxShadow={false}
            onClick={() => {
              if (props.isAgreed) {
                props.shareProfile(props.clinicId, props.currentLocation);
              }
            }}
            loading={props.loading}
            disabled={!props.isAgreed}
          />
          <Button
            className="margin-left-large"
            text="Cancel"
            variant="secondary"
            data-cy="CANCEL-BUTTON"
            boxShadow={false}
            onClick={() => {
              navigate(-1);
            }}
            loading={props.loading}
          />
        </div>
      </div>
    </section>
  );
};

const FetchPatientRecords = (props) => {
  const navigate = useNavigate();

  const linkedCareContextReferenceNumbers = new Set(
    (props.linkedCareContexts || [])
      .flatMap((linkedEntry) => linkedEntry?.careContexts || [])
      .map((linkedCareContext) => linkedCareContext?.referenceNumber)
  );

  const unlinkedPatients = (props.records?.patient || [])
    .map((data) => ({
      ...data,
      careContexts: (data.careContexts || []).filter(
        (careContext) =>
          !linkedCareContextReferenceNumbers.has(careContext?.referenceNumber)
      )
    }))
    .filter((data) => data.careContexts.length > 0);

  const hasUnlinkedRecords = isValidArray(unlinkedPatients);
  const hasPriorLinkedRecords = isValidArray(props.linkedCareContexts);
  // Some HIPs exclude already-linked care contexts from discovery, so an
  // empty discovery response for a clinic we've already linked records at
  // means everything is linked, not that nothing was found. Require
  // hasPriorLinkedRecords so a patient discovered with zero care contexts
  // to begin with isn't mistaken for "already linked".
  const allRecordsLinked = !hasUnlinkedRecords && hasPriorLinkedRecords;

  return (
    <section className="inherit-parent-height ">
      {props.loading && <DocumentCardLoading />}

      {!props.loading && hasUnlinkedRecords && (
        <section
          className={`inherit-parent-height display-flex flex-direction-column flex-justify-content-space-between padding-larger`}
        >
          <div className="overflow-y-auto ">
            <div className="padding-bottom-large text-align-center letter-spacing-4-percentage font-family-gilroy-regular font-color-secondary font-size-small position-sticky top-0 background-white z-index-1 ">
              Select your records
            </div>
            <ul className="abdm-care-context-document-card-border-bottom list-style-none overflow-y-auto  ">
              {unlinkedPatients.map((data) =>
                data.careContexts?.map((careContext) => (
                  <li key={careContext?.referenceNumber}>
                    <DocumentCard
                      data={careContext}
                      // dateOfIssued={dateAndTimeConverter(+new Date())}
                      checkBoxName={careContext?.referenceNumber}
                      clinicLocation={props.location}
                      // documentType="Report"
                      checkBoxChecked={
                        isValidObject(props.selectedCareContexts) &&
                        Object.keys(props.selectedCareContexts).includes(
                          careContext?.referenceNumber
                        )
                      }
                      checkBoxOnChange={(event) => {
                        if (event.target.checked === true) {
                          props.setSelectedCareContexts({
                            ...props.selectedCareContexts,
                            [careContext?.referenceNumber]: careContext
                          });
                        } else if (event.target.checked === false) {
                          const removeKey = (key, { [key]: _, ...rest }) =>
                            rest;
                          const data = removeKey(
                            careContext?.referenceNumber,
                            props.selectedCareContexts
                          );
                          props.setSelectedCareContexts(data);
                        }
                      }}
                    />
                  </li>
                ))
              )}
            </ul>
          </div>
          <Button
            text="Link selected"
            data-cy="SEND-OTP-TO-FETCH-RECORDS"
            boxShadow={false}
            // className="font-family-gilroy-medium  padding-bottom-large"
            disabled={
              isValidObject(props.selectedCareContexts) &&
              Object.keys(props.selectedCareContexts).length >= 1
                ? false
                : true
            }
            loading={props.otpLoading}
            onClick={() => {
              props.fetchOnClick(props.selectedCareContexts);
            }}
          />
        </section>
      )}

      {!props.loading && props.records?.serverError === true && (
        <ServerDownFallback
          onClick={(event) => {
            if (typeof props.retryOnClick === "function") {
              props.retryOnClick(event);
            }
          }}
        />
      )}

      {!props.loading &&
        props.records?.serverError !== true &&
        !hasUnlinkedRecords &&
        !allRecordsLinked && (
          <NoDocumentsFound
            onClick={(event) => {
              if (typeof props.retryOnClick === "function") {
                props.retryOnClick(event);
              }
            }}
          />
        )}

      {!props.loading &&
        props.records?.serverError !== true &&
        !hasUnlinkedRecords &&
        allRecordsLinked && (
          <AllRecordsLinkedFallback
            onClick={() => {
              navigate("/");
            }}
          />
        )}
    </section>
  );
};

const DocumentCardLoading = () => {
  return (
    <section
      className="padding-left-larger padding-right-larger padding-top-large padding-bottom-large"
      data-cy="document-card-loading"
    >
      <div className="inherit-parent-width display-flex flex-justify-content-center padding-bottom-large">
        <div className="shimmer width-150px padding-small  border-radius-default ">
          <div className="padding-small  border-radius-default" />
        </div>
      </div>

      {[...Array(5)].map((_data, index) => (
        <section
          key={index}
          className="flex-center-children-vertically padding-bottom-larger"
        >
          <div className="shimmer padding-small border-radius-25-percentage height-width-16px" />
          <div>
            <div className="shimmer margin-left-larger padding-default border-radius-default width-200px " />
            <div className="shimmer margin-left-larger margin-top-default padding-small border-radius-default width-150px ">
              <div className="padding-smaller" />
            </div>
          </div>
        </section>
      ))}
    </section>
  );
};

// const SearchFallBack = () => {
//   return (
//     <section
//       className="padding-left-larger padding-right-larger padding-top-large margin-top-larger padding-bottom-large"
//       data-cy="document-card-loading"
//     >
//       {[...Array(5)].map((data) => (
//         <section
//           key={data}
//           className="flex-center-children-vertically padding-bottom-larger"
//         >
//           <div className="shimmer padding-large border-radius-100-percentage" />
//           <div>
//             <div className="shimmer margin-left-larger padding-default border-radius-default width-200px " />
//             <div className="shimmer margin-left-larger margin-top-default padding-small border-radius-default width-150px ">
//               <div className="padding-smaller" />
//             </div>
//           </div>
//         </section>
//       ))}
//     </section>
//   );
// };

const ServerDownFallback = ({ onClick }) => {
  return (
    <section className="inherit-parent-height display-flex flex-direction-column flex-justify-content-space-between overflow-y-auto">
      <section />
      <section
        className="text-align-center flex-place-children-page-center"
        data-cy="server-down-fallback"
      >
        <CrashIcon color="#959595" />
        <div className="font-family-gilroy-bold font-size-medium font-color-secondary padding-top-large padding-default">
          Couldn&apos;t Connect
        </div>
        <div className="font-family-gilroy-regular font-size-medium font-color-secondary padding-top-default padding-bottom-default padding-right-large padding-left-large line-height-140-percentage">
          We are sorry. Unable to contact your health programme. Please try
          again later
        </div>
      </section>
      <div className="padding-larger">
        <Button
          text="Retry"
          boxShadow={false}
          className="font-family-gilroy-medium margin-horizontal-auto"
          data-cy="server-down-retry-button"
          onClick={(e) => {
            if (typeof onClick !== "function") return;
            onClick(e);
          }}
        />
      </div>
    </section>
  );
};

const NoDocumentsFound = ({ onClick }) => {
  return (
    <section className="inherit-parent-height display-flex flex-direction-column flex-justify-content-space-between overflow-y-auto">
      <section />
      <section
        className="text-align-center flex-place-children-page-center "
        data-cy="empty-documents-fallback"
      >
        <img
          src={emptyDocument}
          alt="empty-doc"
          width="100%"
          height="150px"
          className="padding-default margin-bottom-large"
        />
        <div className="font-family-gilroy-bold font-size-medium font-color-secondary padding-default">
          No records found.
        </div>
        <div className="font-family-gilroy-regular font-size-medium font-color-secondary padding-top-default padding-bottom-default padding-right-large padding-left-large line-height-140-percentage">
          Try fetching records from this clinic / lab to get any record
          associated with you in your health locker
        </div>
      </section>
      <div className="padding-larger">
        <Button
          text="Retry"
          boxShadow={false}
          className="font-family-gilroy-medium margin-horizontal-auto"
          onClick={(e) => {
            if (typeof onClick !== "function") return;
            onClick(e);
          }}
        />
      </div>
    </section>
  );
};

const AllRecordsLinkedFallback = ({ onClick }) => {
  return (
    <div className="inherit-parent-height padding-larger inherit-parent-width">
      <ProcessSuccess
        title="All your existing records are linked."
        description="NO ADDITIONAL RECORDS AVAILABLE FOR LINKING"
        confirmClick={(e) => {
          if (typeof onClick !== "function") return;
          onClick(e);
        }}
      />
    </div>
  );
};

// const SuggestClinic = () => {
//   return (
//     <div className="flex-center-children-horizontally flex-direction-column">
//       <div className="text-align-center  padding-top-large">
//         <img
//           className="health-id-benefits-icons-size"
//           src={searchIcon}
//           alt="searchIcon"
//         />
//       </div>
//       <div className="text-align-center padding-top-large">
//         Can’t find your clinic / lab?
//       </div>
//       <div className="text-align-center padding-top-large">
//         Suggest the clinic or lab you have records linked. We will try our best
//         to onboard them to Ninto as soon as possible.
//       </div>
//       <Button
//         text="Suggest clinic"
//         boxShadow={false}
//         className="font-family-gilroy-medium max-width-150px padding-top-large margin-horizontal-auto margin-bottom-larger margin-top-large"
//         // onClick={(e) => {
//         //   if (typeof onClick !== "function") return;
//         //   onClick(e);
//         // }}
//       />
//     </div>
//   );
// };

// function dateAndTimeConverter(timestamp) {
//   if (!timestamp) return;
//   let dateObject = new Date(timestamp);
//   const date =
//     timestamp >= new Date().setHours(0, 0, 0, 0)
//       ? "Today"
//       : timestamp >= new Date().setHours(0, 0, 0, 0) - 86400000 &&
//         timestamp < new Date().setHours(0, 0, 0, 0)
//         ? "Yesterday"
//         : dateObject.toLocaleString("en-IN", { day: "2-digit"}) +
//         ""+
//         dateObject.toLocaleString("en-IN", { month: "short"}) +
//         ""+
//         dateObject.toLocaleString("en-IN", { year: "numeric"});
//   return date;
//   // date + ","+ dateObject.toLocaleString("en-IN", { timeStyle: "short"})
// }

const OTPModal = (props) => {
  const [resendCount, setResendCount] = useState(0);
  const [counter, setCounter] = useState(null);
  const [running, setRunning] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let counterTimer;

    if (counter && typeof counter === "number" && running) {
      counterTimer = setTimeout(() => {
        setCounter(counter - 1);
      }, 1000);
      return;
    }
    setCounter(null);
    setRunning(false);
    return () => clearTimeout(counterTimer);
    // eslint-disable-next-line
  }, [counter]);

  useEffect(() => {
    setCounter(60);
    setRunning(true);

    return () => {
      // cleanup on unmount
      setCounter(null);
      setRunning(false);
    };
  }, []);

  return (
    <Modal
      canIgnore={true}
      onClose={() => {
        clearLinkRefNumber();
        navigate(-1);
      }}
      show={true}
      position="position-fixed bottom-0"
      boxShadow="none"
      borderRadius="none"
      width="inherit-parent-width"
      background="background-transparent"
      height="height-fit-to-content"
    >
      <div
        data-cy="OTP-VERIFY-MODAL"
        className="background-white border-top-radius-default padding-default font-family-gilroy-medium font-color-secondary flex-justify-content-space-between flex-align-items-center flex-direction-column font-size-medium padding-larger "
      >
        <>
          <OTPInputBox
            name="otp"
            setValue={props.setOTPValue}
            className="margin-bottom-larger"
            required
          />
          <div className="display-flex inherit-parent-width flex-justify-content-space-between font-size-medium margin-bottom-larger">
            {counter && typeof counter === "number" && resendCount <= 1 ? (
              <div>{`00:${counter?.toString().padStart(2, "0")} seconds`}</div>
            ) : (
              <div />
            )}
            <div
              className={`${
                typeof counter === "number" && counter > 0
                  ? "font-color-tertiary"
                  : "font-color-primary"
              }`}
              onClick={() => {
                const isTimerActive =
                  typeof counter === "number" &&
                  counter > 0 &&
                  props.resendCount <= 1;
                // Disable only while timer is running
                if (isTimerActive) {
                  return;
                }

                // Limit after 2 resends
                if (resendCount >= 2) {
                  return setErrorStatus({
                    code: "custom",
                    message: "OTP Resend limit reached. Try after 30 minutes."
                  });
                }
                props.resendOTPOnClick();
                // First resend -> show timer
                const nextCount = resendCount + 1;

                setResendCount(nextCount);

                // Only first resend should start timer
                if (nextCount === 1) {
                  setCounter(60);
                } else {
                  // second resend onwards
                  setCounter(null);
                }
              }}
            >
              Resend OTP
            </div>
          </div>
        </>
        <Button
          text="Fetch records"
          boxShadow={false}
          loading={props.loading}
          disabled={props.disableButton}
          data-cy="CONFIRM-OTP-TO-FETCH-RECORDS"
          className="font-family-gilroy-medium max-width-150px margin-horizontal-auto margin-top-larger"
          onClick={props.fetchRecordsClick}
        />
      </div>
    </Modal>
  );
};

const PermissionDeniedFallback = (props) => {
  // for iphone only
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    props.onEnableClick();
  }
  const LocationFallBackIcon = () => {
    return (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M33.7504 52.5L33.1904 51.38L25.0004 35L7.50042 26.25C7.26107 26.1403 7.05824 25.9642 6.91604 25.7426C6.77383 25.521 6.69824 25.2633 6.69824 25C6.69824 24.7367 6.77383 24.479 6.91604 24.2574C7.05824 24.0358 7.26107 23.8597 7.50042 23.75L52.5004 7.5L43.4454 32.575"
          stroke="#E5E5E5"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55 55L42.5 42.5"
          stroke="#E5E5E5"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.5 55L55 42.5"
          stroke="#E5E5E5"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  return (
    <div
      className="inherit-parent-width inherit-parent-height"
      style={{ height: "calc(100% - 138px)" }}
    >
      <div
        className="inherit-parent-height padding-large display-flex flex-direction-column flex-justify-content-center flex-align-items-center"
        data-cy="location-permission-denied-fallback"
      >
        <div className="inherit-parent-height padding-horizontal-large display-flex flex-direction-column flex-justify-content-center flex-align-items-center">
          <div>{LocationFallBackIcon}</div>
          <div className="padding-top-larger font-color-tertiaryColor6">
            {props.title}
          </div>
          <div className=" padding-top-medium text-align-center font-size-medium font-color-tertiaryColor5">
            {props.description}
          </div>
        </div>
        {props.showButton && (
          <div className="inherit-parent-width">
            <Button
              boxShadow={false}
              type="button"
              text="Enable"
              disabled={/iPhone|iPad|iPod/i.test(navigator.userAgent)}
              onClick={props.onEnableClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};

// {
//   type: 'SET_ABDM_SEARCHED_CLINIC_CARE_CONTEXTS',
//   payload: {
//     'NINTO-TEST-CLINIC': {
//       transactionId: 'a9d6f177-4b89-4e0b-97a8-07986bea5bff',
//       patient: [
//         {
//           referenceNumber: 'lovely1test@sbx',
//           display: 'Operation success',
//           careContexts: [
//             {
//               referenceNumber: '6b1bcb8a-6ba7-4457-8df1-26424a137a83',
//               display: 'Rana Hospital-9/27/2025-11:23:51 AM'
//             }
//           ],
//           hiType: 'HealthDocumentRecord',
//           count: 1
//         }
//       ],
//       createdAt: '2025-09-27T05:54:27.806Z',
//       response: {
//         requestId: '9aaa3551-9112-42b8-a1a5-74b3d95a15a4'
//       }
//     }
//   }
// }

// {
//     "success": true,
//     "data": {
//         "response": {
//             "requestId": "19544424-d7b0-4c2b-9e05-dec4965a0d11"
//         },
//         "patient": [
//             {
//                 "referenceNumber": "0arD0CfSdni2QlJDAatu",
//                 "display": "Records linked successfully",
//                 "careContexts": [
//                     {
//                         "referenceNumber": "6cfc61ec-6c5d-4ed1-9099-58f950cf1cdc",
//                         "display": "Rana Hospital-10/7/2025-3:29:33 PM"
//                     }
//                 ],
//                 "hiType": "HealthDocumentRecord",
//                 "count": 1
//             }
//         ]
//     }
// }
